// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1431":"53086c8f","2887":"83415e88","3464":"456226da","4947":"31d6cfe0","6358":"2edb0355","7802":"3c704cae"}[chunkId] + ".chunk.css";
};